import React, { Component } from "react"
import Validator from "../helpers/validate"
import _ from "lodash"

class Field extends Component {
	constructor(props) {
		super(props)
		this.state = {
			valid: null,
			value: "",
			required: false,
			focused: false,
			hasError: null,
			message: "",
		}

		this.validator = new Validator()
		if (_.includes(this.props.valid, "required")) {
			this.state.required = true
		}
	}

	static getDerivedStateFromProps(props, state) {
		if (props.value !== state && props.value) {
			state.value = props.value
			return state
		}
		return null
	}

	componentDidUpdate(prevProps, prevState) {
		// This is to auto-turn the fields red/green
		if (prevProps.value !== prevState.value && this.props.editing) {
			this.validate(this.props.valid)
		}
	}

	validate(opts) {
		if (opts.length == 0) {
			return
		}
		var status = []
		var ret = true
		opts.map((r) => {
			status.push(this.validator[r](this.state.value))
		})
		status.map((r) => {
			if (r !== true) {
				this.setState({ valid: false, hasError: true, message: r.message })
				this.props.setValid(this.props.id, false)
				ret = r
			}
		})
		if (ret === true) {
			this.setState({ valid: true, hasError: false, message: "" })
			this.props.setValid(this.props.id, true)
		}
		return ret
	}

	_handleChange = (e) => {
		this.setState({ value: e.target.value }, () => {
			//console.log(this.state)
			this.validate(this.props.valid)
		})
		this.props.updateValue(this.props.id, e.target.value, this.props.index)
	}

	_handleFocus = () => {
		this.setState({ focused: true })
	}

	_handleBlur = () => {
		this.setState({ focused: false }, () => {
			this.validate(this.props.valid)
		})
	}

	render() {
		var req = this.state.required ? "*" : ""
		var classNames = require("classnames")
		var classes = classNames("form__fieldGroup", {
			"form__fieldGroup--active": this.state.focused,
			"form__fieldGroup--error": this.state.hasError,
			"form__fieldGroup--success": this.state.valid,
		})

		return (
			<div className={classes}>
				<label htmlFor={this.props.id}>
					{this.props.label}
					<sup>{req}</sup>
				</label>
				<div className="form__message">{this.state.message}</div>
				<input
					type={this.props.type}
					id={this.props.id}
					ref={this.props.id}
					value={this.state.value}
					className="form__input"
					onFocus={this._handleFocus}
					onBlur={this._handleBlur}
					onChange={this._handleChange}
				/>
			</div>
		)
	}
}

export default Field
